import { IPropertyConverter, JsonValueObject, TaJson } from "ta-json";

import { MapStringTo } from "../base-types";
import { MenuItem } from "../models/pages/menu-item";

export class PageResourceMenusConverter implements IPropertyConverter {
    /**
     * Serializes a string map of arrays of {@link MenuItem}s.
     *
     * @param value - The map of strings to arrays of {@link MenuItem}s
     * @returns A JSON value object.
     */
    serialize(value: MapStringTo<Array<MenuItem>>): JsonValueObject {
        const result: JsonValueObject = {};

        Object.keys(value).forEach(menuName => {
            const menu = value[menuName];

            result[menuName] = menu.map(menuItem => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return TaJson.serialize(menuItem);
            });
        });

        return result;
    }

    /**
     * Deserializes a JSON object into a string map of arrays of {@link MenuItem}s.
     *
     * @param value - A JSON object
     * @returns A mapping of strings to arrays of {@link MenuItem}s.
     */
    deserialize(value: JsonValueObject): MapStringTo<Array<MenuItem>> {
        if (!value) {
            return {};
        }

        const result: MapStringTo<Array<MenuItem>> = {};

        Object.keys(value).forEach(menuName => {
            const menu = value[menuName];
            if (Array.isArray(menu)) {
                result[menuName] = menu.map(menuItem => {
                    return TaJson.deserialize<MenuItem>(menuItem, MenuItem);
                });
            }
        });

        return result;
    }
}
